import DateFnsUtils from '@date-io/date-fns'
import { Box, Button, ButtonGroup, Typography } from '@material-ui/core'
import { DatePickerView, KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { isValid } from 'date-fns'

const commonDatePickerProps = {
  views: ['month', 'date'] as DatePickerView[],
  disableFuture: false,
  disablePast: true,
  autoOk: true,
  clearable: true,
  inputVariant: 'outlined' as const,
  format: 'MM/dd/yyyy',
  variant: 'dialog' as const,
  invalidDateMessage: 'Invalid date format',
  KeyboardButtonProps: { 'aria-label': 'change date' },
}

type FilterVisitsProps = {
  visitRange?: {
    type?: 'this-week' | 'this-month' | 'next-month' | 'custom'
    startDate?: Date | null
    endDate?: Date | null
  }
  virtual?: boolean
  collegeFair?: boolean
  onChangeVisit: (option?: string) => void
  onChangeType: (formType: 'virtual' | 'collegeFair', value?: boolean) => void
  onChangeVisitDates: (dates: { startDate?: Date | null; endDate?: Date | null }) => void
}

const FilterVisits = ({
  visitRange,
  virtual,
  collegeFair,
  onChangeVisit,
  onChangeVisitDates,
  onChangeType,
}: FilterVisitsProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gridGap={24}
    >
      <Typography
        component="div"
        variant="h6"
      >
        Visits
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={16}
      >
        <Typography variant="subtitle2">Availability</Typography>
        <ButtonGroup
          disableFocusRipple
          color="primary"
        >
          <Button
            variant={visitRange?.type === 'this-week' ? 'contained' : 'outlined'}
            onClick={() => (visitRange?.type === 'this-week' ? onChangeVisit(undefined) : onChangeVisit('this-week'))}
          >
            This Week
          </Button>
          <Button
            variant={visitRange?.type === 'this-month' ? 'contained' : 'outlined'}
            onClick={() => (visitRange?.type === 'this-month' ? onChangeVisit(undefined) : onChangeVisit('this-month'))}
          >
            This Month
          </Button>
          <Button
            variant={visitRange?.type === 'next-month' ? 'contained' : 'outlined'}
            onClick={() => (visitRange?.type === 'next-month' ? onChangeVisit(undefined) : onChangeVisit('next-month'))}
          >
            Next Month
          </Button>
          <Button
            variant={visitRange?.type === 'custom' ? 'contained' : 'outlined'}
            onClick={() => (visitRange?.type === 'custom' ? onChangeVisit(undefined) : onChangeVisit('custom'))}
          >
            Custom
          </Button>
        </ButtonGroup>
        {visitRange?.type === 'custom' && (
          <Box
            mt={2}
            display="flex"
            alignItems={'start'}
            gridGap={8}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Box>
                <KeyboardDatePicker
                  id="visit-availability-start-date"
                  label="From"
                  minDate={new Date()}
                  minDateMessage="Cannot be in the past"
                  maxDateMessage="Must be before To date"
                  value={visitRange?.startDate || null}
                  onChange={(date) => {
                    if (isValid(date) || date === null) {
                      onChangeVisitDates({
                        startDate: date,
                        endDate: visitRange?.endDate,
                      })
                    }
                  }}
                  {...commonDatePickerProps}
                />
              </Box>
              <Box>
                <KeyboardDatePicker
                  id="visit-availability-end-date"
                  label="To"
                  minDateMessage="Must be after From date"
                  minDate={visitRange?.startDate}
                  value={visitRange?.endDate || null}
                  onChange={(date) => {
                    if (isValid(date) || date === null) {
                      onChangeVisitDates({
                        startDate: visitRange?.startDate,
                        endDate: date,
                      })
                    }
                  }}
                  {...commonDatePickerProps}
                />
              </Box>
            </MuiPickersUtilsProvider>
          </Box>
        )}
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={16}
      >
        <Typography variant="subtitle2">Type</Typography>
        <ButtonGroup
          disableFocusRipple
          color="primary"
        >
          <Button
            variant={collegeFair === false ? 'contained' : 'outlined'}
            onClick={() => {
              onChangeType('collegeFair', collegeFair === undefined || collegeFair === true ? false : undefined)
            }}
          >
            High School Visit
          </Button>
          <Button
            variant={collegeFair === true ? 'contained' : 'outlined'}
            onClick={() =>
              onChangeType('collegeFair', collegeFair === undefined || collegeFair === false ? true : undefined)
            }
          >
            College Fair
          </Button>
        </ButtonGroup>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gridGap={16}
      >
        <Typography variant="subtitle2">Format</Typography>
        <ButtonGroup
          disableFocusRipple
          color="primary"
        >
          <Button
            variant={virtual === false ? 'contained' : 'outlined'}
            onClick={() => {
              onChangeType('virtual', virtual === undefined || virtual === true ? false : undefined)
            }}
          >
            In Person
          </Button>
          <Button
            variant={virtual === true ? 'contained' : 'outlined'}
            onClick={() => onChangeType('virtual', virtual === undefined || virtual === false ? true : undefined)}
          >
            Virtual
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
  )
}

export default FilterVisits
